import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { Subscription } from 'rxjs';
import { AdditionalService } from '../../../business-entities/additional-service.interface';
import { AppState } from '../../../business-entities/app-state.interface';
import { SelectDealer } from '../../../business-services/select-dealer.service';
import { SettingService } from '../../../business-services/setting.service';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CommonService } from './../../../services/commom.service';
import * as Enums from './../../../utils/enums';
import { Features } from '../../../business-entities/step.class';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { SelectService } from '../../../business-services/select-service.service';

@Component({
  selector: 'app-additional-services',
  templateUrl: './additional-services.component.html'
})
export class AdditionalServicesComponent implements OnInit {
  appData: AppState;
  additionalServices: any[] = [];
  dealerRecommendedService: AdditionalService[] = [];
  additionServicesForm: FormGroup;
  stonchip: string;
  displaySelectedDate: Date;
  currentlagSub: Subscription;
  currentlanguage: string;
  features: Features[] = [];
  isShareBoxEnable: boolean = false;
  allWarningLight:any[]=[];
  isWarningLightFeature: boolean =false;
  @Output() openAnotherPanelRequest = new EventEmitter<string>();

  constructor(
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private sdService: SelectDealer,
    public settingService: SettingService,
    private currentLanguageService: CurrentLanguage,
    private secureStorage: SecureStorage,
    private ssService: SelectService,
  ) { }

  ngOnInit(): void {
    this.initialize();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentlanguage = x;
    })
    this.currentlanguage = this.currentlanguage ? this.currentlanguage : 'en-US'
    if(this.isWarningLightFeature)
    {
      this.allWarningLight =this.commonService.allWarningLight;
    }
    
    this.appData = this.commonService.getAppData();
    this.displaySelectedDate = this.appData.displaySelectedDate;
    this.goToAdditionalServiceSection();
    
  }

  initialize() : void{
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.isShareBoxEnable = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.ShareBox)?.isActive;
        if(this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WarningLight))
        this.isWarningLightFeature=this.features.find(x => x.featureCode === CommonEnums.FeatureCode.WarningLight)?.isActive;
      }
    }
  }

 //async GetWarningLight() {
    // await this.ssService.getWarningLightDropDown(this.currentlanguage)
    //   .then((response) => {
    //     this.allWarningLight = response;
    //   });
  //}

  removeSelectedServicesFromRecommendations(dealerRecommendedService: AdditionalService[]): void {
    const service = dealerRecommendedService.filter(x =>
      this.appData.selectedService.findIndex(y => y.id === x.serviceId) === -1
    );
    this.additionServicesForm = new FormGroup({});
    const appData = this.commonService.getAppData();
    this.stonchip = appData.otherIssuesInput;
    service.forEach(x => {
      let value = null;
      if (appData.selectedAdditionService) {
        value = appData.selectedAdditionService[x.serviceId.toString()];
      }
      this.additionServicesForm.addControl(x.serviceId.toString(), new FormControl(value, []));
    });
    this.dealerRecommendedService = service;
    this.commonService.dealerRecommendedService = this.dealerRecommendedService;
  }

  goToAdditionalServiceSection(): void {
    this.spinner.show();
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.currentlanguage = x;
    })
    this.currentlanguage = this.currentlanguage ? this.currentlanguage : 'en-US'
    this.sdService.GetAdditionalServices(this.appData.selectedDealer.dealerId, this.currentlanguage)
      .then((result) => {
        if (result?.responseObject && result.responseObject.errorCount === 0
          && result.responseCode === CommonEnums.ErrorCodes.SuccessCode) {
          const dealerRecommendedService = result.responseObject.result as AdditionalService[];
          dealerRecommendedService.forEach(element => {
            element.selectedWarningLightId='';
            let warrantyLightList;
            if(this.isWarningLightFeature && element.isWarningLight && element.warningLightId!=='' && element.warningLightId!==null  && element.warningLightId!==undefined)
            {
              warrantyLightList = element.warningLightId.split(',');
              element.warningLightIdList=[];
              
              this.allWarningLight.forEach(warrentyLight => {
                warrantyLightList.forEach(associatedWarrentyLight => {
                  if(warrentyLight.id.toString()===associatedWarrentyLight)
                  {
                    const warrentyLightModel=
                    {
                      Id:warrentyLight.id,
                      Image:warrentyLight.logo,
                      WarningNameName:warrentyLight.warningName,
                      IsSelected:false
                    }
                    element.warningLightIdList.push(warrentyLightModel);
                  }
                });
              });
            }
          });
          this.removeSelectedServicesFromRecommendations(dealerRecommendedService);
        } else if (result.responseObject && result.responseObject.errorCount > 0) {
          if (result.responseObject.result &&
            result.responseObject.result.errorCode === CommonEnums.ErrorCodes.DealerAdditionalServiceNotFound) {
            this.dealerRecommendedService = [];
          }
        }
        this.spinner.hide();
      });
  }

  Onsubmit() {
    this.commonService.addselectedAdditionService(this.additionServicesForm, this.dealerRecommendedService);
    this.commonService.completePanel(Enums.PanelIds.Panel4);
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel5);
  }

  goToPrevious(): void {
    this.openAnotherPanelRequest.emit(Enums.PanelIds.Panel3);
  }

  onSelectWarningLight(warningLight:any,service:any)
  {
    warningLight.isSelected=!warningLight.isSelected;
    let result = service.selectedWarningLightId.includes(warningLight.Id);
    if(!result)
    {
      service.selectedWarningLightId+= warningLight.Id + ',';
    }
    if(!warningLight.isSelected && service.selectedWarningLightId.includes(warningLight.Id))
    {
      let value=warningLight.Id+',';
      service.selectedWarningLightId=service.selectedWarningLightId.replace(value,'');
    }
  }

  checkIfServiceSelected(selectedServiceId: any): boolean {
    if(this.additionServicesForm.controls[selectedServiceId].value)
      return true;
    return false;
  }
}